import React from "react";
import Text from "../../../atoms/text/Text";

import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import Toggle from "../../../atoms/toggle/Toggle";
import Button from "../../../atoms/button/Button";

interface Props {
  heading?: string;
  mode: "fullscreen" | "thumbnails";
  setMode: (val: "fullscreen" | "thumbnails") => void;
  children?: React.ReactNode;
  onRefresh?: () => void;
}

const ReportingTemplatePreviewHeader = React.forwardRef<HTMLDivElement, Props>(
  ({ heading, mode, setMode, children, onRefresh }, ref) => {
    ReportingTemplatePreviewHeader.displayName =
      "ReportingTemplatePreviewHeader";
    return (
      <InlineGroup ref={ref} verticalCenter spread>
        <h2>{heading ?? "Reporting Template Preview"}</h2>
        <InlineGroup spaceBetweenElements={2} verticalCenter>
          {children}
          {onRefresh && <Button onClick={onRefresh}>Refresh</Button>}
          <InlineGroup spaceBetweenElements={2} verticalCenter>
            <Text>Fullscreen:</Text>
            <Toggle
              checked={mode === "fullscreen"}
              onUpdate={() => {
                setMode(mode === "fullscreen" ? "thumbnails" : "fullscreen");
              }}
            />
          </InlineGroup>
        </InlineGroup>
      </InlineGroup>
    );
  },
);

export default ReportingTemplatePreviewHeader;
